import { Snackbar, Alert } from '@mui/material'
import { useSnackbarStore } from '@/store/snackbarStore'
import { SyntheticEvent } from 'react'

/**
 * GlobalSnackbar Component
 *
 * A site-wide notification component that displays messages, warnings,
 * and errors from anywhere in the application.
 *
 * Usage:
 * - Import useSnackbarStore in any component
 * - Call showSnackbar() with the message and options
 */
export const GlobalSnackbar = () => {
  const { open, message, severity, autoHideDuration, variant, hideSnackbar } = useSnackbarStore()

  const handleClose = (_event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    hideSnackbar()
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant={variant}
        sx={{
          width: '100%',
          '& .MuiAlert-message': {
            // Support both string and JSX content
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default GlobalSnackbar
